import { hasPendingKeysSecretsRotationAtom } from "../../shared/atoms";
import { getAdminKeysSecretsStatus } from "../services/admin-keys-secrets.service";
import { useSetAtom } from "jotai";
import { useEffect } from "react";

export function useAdminKeysSecretsPendingRotationStatus(isAdmin: boolean) {
  const setHasPendingKeysSecretsRotation = useSetAtom(hasPendingKeysSecretsRotationAtom);

  useEffect(() => {
    if (!isAdmin) {
      setHasPendingKeysSecretsRotation(false);
      return;
    }

    let isCurrentRequest = true;
    let retryTimeoutId: number | undefined;

    const loadRotationStatus = () => {
      getAdminKeysSecretsStatus()
        .then((rotationStatus) => {
          if (!isCurrentRequest) {
            return;
          }

          setHasPendingKeysSecretsRotation(rotationStatus.hasPendingRotation);

          if (rotationStatus.nextMailboxScanAt) {
            const nextMailboxScanTimestamp = Date.parse(rotationStatus.nextMailboxScanAt);
            if (Number.isFinite(nextMailboxScanTimestamp)) {
              const retryDelay = Math.max(nextMailboxScanTimestamp - Date.now(), 1000);
              retryTimeoutId = window.setTimeout(loadRotationStatus, retryDelay);
            }
          }
        })
        .catch(() => {
          if (retryTimeoutId) {
            window.clearTimeout(retryTimeoutId);
          }
        });
    };

    loadRotationStatus();

    return () => {
      isCurrentRequest = false;
      if (retryTimeoutId) {
        window.clearTimeout(retryTimeoutId);
      }
    };
  }, [isAdmin, setHasPendingKeysSecretsRotation]);
}
